module.exports = __webpack_public_path__ + "static/media/datafiniti-logo-white.20e52ab5.svg";